// import { IconButton } from "plos/src/components/buttons/IconButton";
import { Sheet } from "plos/src/components/Sheet";
import { ElementIconButton } from "plos/src/components/tooltips/ElementIconButton";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  contextualHelpContainer,
  helpButtonIcon,
  helpButtonIconContainer,
  helpSheetContent,
} from "./contextualHelp.css";

interface ContextualHelpProps {
  title: string;
  children: ReactNode;
  onOpen?: () => void;
}

const ContextualHelpSheet = ({
  title,
  children,
  onOpen,
}: ContextualHelpProps) => {
  const { t } = useTranslation("help");

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    onOpen?.();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={contextualHelpContainer}>
      <div className={helpButtonIconContainer}>
        <ElementIconButton
          onPress={handleOpen}
          label={t("helpIcon", "Help with this page")}
        >
          <span className={helpButtonIcon}>?</span>
        </ElementIconButton>
      </div>
      <Sheet
        headerSize="xl"
        title={title}
        open={open}
        handleClose={handleClose}
      >
        <div className={helpSheetContent}>{children}</div>
      </Sheet>
    </div>
  );
};

export default ContextualHelpSheet;
